<!--头部导航-->
<template>
  <div class="app-nav">
    <ul class="nav" :class="{dark}">
      <li v-for="(item, idx) in nav" :key="idx" :class="{active: item.name === activeRoute}" class="nav-item" @click="jumpPage(item.path)">{{ $t(`nav.${item.name}`) }}</li>
    </ul>
  </div>
</template>

<script>
import { getRouterByName } from '@/utils/common.js'
export default {
  name: 'AppNav',
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  data() {
    return {
      nav: [
        /*{
          name: 'index' // 首页
        },
        {
          name: 'about' // 关于
        }*/
      ]
    }
  },
  computed: {
    activeRoute() {
      return this.$route.name
    }
  },
  mounted() {
    this.initNav(this.nav)
  },
  methods: {
    initNav(nav) {
      const nv = [...nav]
      for (let i of nv) {
        i.path = getRouterByName(i.name)
      }
      this.$set(this, 'nav', nv)
    },
    jumpPage(path) {
      this.$router.push({path})
    },
    jumpPageByName(name) {
      this.$router.push({name})
    }
  }
}
</script>

<style lang="scss" scoped>
.app-nav {
  .nav {
    .nav-item {
      display: inline-block;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 25px;
      margin-right: 80px;
      cursor: pointer;
      opacity: 0.8;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        font-weight: bold;
        opacity: 1;
      }
    }
    &.dark {
      .nav-item {
        color: #1E1E20
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/components/pc/nav/index.vue